import React from 'react';
import { DOMAIN } from '../config';
import MetaDecorator from '../components/common/loader/metaDecorator';
import imgUrl from '../images/satsang.jpg';

const TermsOfService = () => {
  return (
    <div>
      <MetaDecorator
        title="Terms of Service"
        description="Terms of Service for Badela Dham Bharatvarsh"
        imgSrc={imgUrl}
      />
      <div className="container" style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '30px', color: '#333' }}>Terms of Service</h1>

        <div style={{ lineHeight: '1.8', color: '#555', fontSize: '16px' }}>
          <p style={{ marginBottom: '20px' }}>
            By using this application, you agree to the following terms.
          </p>

          <p style={{ marginBottom: '20px' }}>
            This application is used only to manage and analyze the official
            Facebook Page "Badela Dham Bharatvarsh" owned by the same organization.
          </p>

          <p style={{ marginBottom: '20px' }}>
            The application does not provide services to the public and does not
            sell or share any user data.
          </p>

          <p style={{ marginBottom: '20px' }}>
            All access to Facebook data is governed by Facebook Platform Policies.
          </p>

          <p style={{ marginBottom: '20px' }}>
            We reserve the right to update these terms at any time without prior
            notice.
          </p>

          <p style={{ marginTop: '40px', marginBottom: '20px' }}>
            If you have any questions about these terms, please contact us at:
          </p>

          <p style={{ marginBottom: '20px' }}>
            <strong>Email:</strong>{' '}
            <a href="mailto:badeladhambharatvarsh@gmail.com" style={{ color: '#0066cc' }}>
            badeladhambharatvarsh@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;




// WEBPACK FOOTER //
// ./src/pages/TermsOfService.jsx